export default __webpack_public_path__ + "static/media/infoPanel2.db908a91.webp";